// 获取url指定参数
export function getParame(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substring(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  }
  return null;
}

// 格式化时长
export const formatDuration = (
  duration: any,
  options: { showH?: boolean; showMin?: boolean; showS?: boolean } = {},
) => {
  let { showH = true, showMin = true, showS = true } = options;
  if (typeof duration !== 'number') {
    return duration.toString();
  }
  let hours = Math.floor(duration / 3600);
  let minutes = Math.floor((duration % 3600) / 60);
  let seconds = duration % 60;
  let result = '';
  if (showH && hours > 0) {
    result += `${hours}小时`;
  }
  if (showMin || (!showH && hours === 0)) {
    result += `${minutes}分钟`;
  }
  if (showS || (!showMin && minutes === 0 && (!showH || hours === 0))) {
    result += `${seconds}秒`;
  }

  return result.trim();
};

// 格式化时长
export const formatDurationNew = (
  duration: any,
  options: { showH?: boolean; showMin?: boolean; showS?: boolean } = {},
) => {
  let { showH = true, showMin = true, showS = true } = options;
  if (typeof duration === 'number') {
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor((duration % 3600) / 60);
    let seconds = duration % 60;
    let result = '';
    if (showH && hours > 0) {
      result += `${hours} 小时 `;
    }
    if (showMin || (!showH && hours === 0)) {
      result += `${minutes} 分`;
    }
    if (showS || (!showMin && minutes === 0 && (!showH || hours === 0))) {
      result += `${seconds} 秒`;
    }
    return result.trim();
  }
};

export const formatDurationSimple = (
  duration: any,
  options: { showH?: boolean; showMin?: boolean; showS?: boolean } = {},
) => {
  let { showH = true, showMin = true, showS = true } = options;
  if (typeof duration === 'number') {
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor((duration % 3600) / 60);
    let seconds = duration % 60;
    let result = '';
    if (showH && hours > 0) {
      result += `${hours} 小时 `;
    }
    if (showMin && minutes > 0) {
      result += `${minutes} 分`;
    }
    if (showS || (!showMin && minutes === 0 && (!showH || hours === 0))) {
      result += `${seconds} 秒`;
    }
    return result.trim();
  }
};

export const formatVideoDuration = (duration: any) => {
  if (typeof duration === 'number') {
    if (duration >= 60 && duration <= 3600) {
      return `${parseInt(String(duration / 60))}分`;
    } else {
      const hour = parseInt(String(duration / 3600));
      const min = parseInt(String((duration - hour * 3600) / 60));
      const seconds = duration - hour * 3600 - min * 60;
      return `${hour}小时${min}分`;
    }
  }
  return duration;
};

export function daysUntil(targetDateString: any) {
  const targetDate = new Date(targetDateString);
  const now = new Date();
  const diff = targetDate.getTime() - now.getTime();
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

  return days;
}

export function isMobileValue() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  );
  const isMobile = flag ? 'mobile' : 'pc';
  return isMobile;
}

export class Timer {
  private timerId: NodeJS.Timeout | null = null;
  private callback: () => void;
  private interval: number;

  constructor(callback: () => void, interval: number) {
    this.callback = callback;
    this.interval = interval;
  }

  start(): void {
    if (!this.timerId) {
      this.timerId = setInterval(this.callback, this.interval);
    }
  }

  stop(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
}

export function getRealName(entryValue: any, realName?: string) {
  if (!entryValue) {
    return realName || '--';
  }
  const foundItem = entryValue.find((item: any) => item.name === '真实姓名');
  if (foundItem) {
    return foundItem.value;
  }
  return realName || '--';
}

export function getAdjustedHeight(subtractValue: number): number {
  let currentAdjustedHeight: number;

  function calculateHeight() {
    const pageHeight = window.innerHeight;
    currentAdjustedHeight = pageHeight - subtractValue;
    return currentAdjustedHeight;
  }

  // 初始化计算高度
  const initialHeight = calculateHeight();
  console.log(`初始调整后的高度是: ${initialHeight}px`);

  // 监听窗口大小变化事件
  window.addEventListener('resize', () => {
    const newHeight = calculateHeight();
    console.log(`页面缩放后，调整后的高度是: ${newHeight}px`);
  });

  return initialHeight;
}
